import Dot from '../../components/Dot';
import { ReactComponent as Arrow } from '../../../../../icons/icon-arrow.svg';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { useCallback } from 'react';

const Back = () => {
  const { formatMessage } = useIntl();

  const handleRemoveBodyOverflow = useCallback(() => {
    document.body.classList.remove('is-overflow-hidden');
  }, []);

  return (
    <div className='integration__back' onClick={handleRemoveBodyOverflow}>
      <Link to='/integrations'>
        <Dot rotate='180'>
          <Arrow />
        </Dot>

        {formatMessage({ id: 'Integrations' })}
      </Link>
    </div>
  );
};

export default Back;
